__turbopack_context__.v({
  "label": "eXhtJW_label",
  "learnMoreLink": "eXhtJW_learnMoreLink",
  "tooltipContent": "eXhtJW_tooltipContent",
});
